import type { IMultiplacerModuleKey } from "@multiconsult-group/multiplacer-core";
import { DesignRole } from "@multiconsult-group/multiplacer-core";
import type { IconType } from "react-icons";
import {
  FaClipboardCheck,
  FaCloudSun,
  FaExchangeAlt,
  FaHashtag,
  FaProjectDiagram,
  FaSearch,
  FaUser,
  FaUsersCog,
  FaUserTie,
} from "react-icons/fa";

export const MODULE_ICON_BY_KEY: Record<IMultiplacerModuleKey, IconType> = {
  CEILING: FaCloudSun,
  ROOM_VALIDATION: FaClipboardCheck,
  EXPLORE: FaSearch,
  ROOM_NUMBERING: FaHashtag,
  DROFUS_CHANGE_MANAGEMENT: FaExchangeAlt,
};

export const ROLE_ICON_BY_KEY: Record<DesignRole, IconType> = {
  [DesignRole.BIM_SAMORDNER]: FaProjectDiagram,
  [DesignRole.PROSJEKTERANDE]: FaUser,
  [DesignRole.DISCIPLINELEDER]: FaUsersCog,
  [DesignRole.PROSJEKTLEDER]: FaUserTie,
};
